import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root"
})
export class ETADateUpdationService {
  constructor(private http: HttpUtilService) {}

  updateVehicleETA(payload: any): Observable<any> {
    return this.http.post("UpdateVehicleRateService.asmx/UpdateVehicleETA", payload);
  }
}